module.exports = __webpack_public_path__ + "img/view.be343e11.svg";